/**
 * VENDOR MODULES
 */
import React from 'react';

import { isFalsy } from 'shared/utils/common';
import Emitter     from 'shared/events/emitter';
import EVENT_NAMES from 'shared/constants/events';
import { getSportIdForImagePath } from 'shared/utils/sport-colors';
import { withBasePath } from 'shared/utils/runtimeBasePath';

/**
 * Parse evolution data from event_results.evolution
 * Evolution data is now stored in videos_racing table as JSON string
 * Format: {"1":{"t":6,"o":"1-3-4"},"2":{"t":7,"o":"1-3-2"},...}
 */
function parseEvolutionData(evolutionData) {
  if (isFalsy(evolutionData)) {
    return [];
  }

  try {
    const evolution = typeof evolutionData === 'string'
      ? JSON.parse(evolutionData)
      : evolutionData;

    return Object.entries(evolution)
      .filter(([key]) => !isNaN(parseInt(key))) // Filter out non-numeric keys
      .map(([key, val]) => ({
        start_time: val.t,
        value: val.o
      }))
      .filter(item => typeof item.value === 'string' && /^\d+(-\d+)+$/.test(item.value)) // Only valid runner-order strings (e.g. "1-3-4"); exclude inizio_replay, fine_replay
      .filter(item => item.start_time !== '' && item.start_time !== undefined)
      .sort((a, b) => parseFloat(a.start_time) - parseFloat(b.start_time));
  } catch (e) {
    console.warn('Failed to parse evolution data:', e);
    return [];
  }
}

/***/
function VideoEvolutions(props) {
  const [evol1_source, setEvol1Source] = React.useState(null);
  const [evol2_source, setEvol2Source] = React.useState(null);
  const [evol3_source, setEvol3Source] = React.useState(null);

  const onEvolutionChange = ({time, event_results}) => {
    const {
      n_runners,
      sport_id,
      evolution: evolutionData,
    } = event_results;

    // Evolution data now comes from event_results.evolution (from videos_racing table)
    const current_evolutions = parseEvolutionData(evolutionData);

    if (!current_evolutions.length) {
      return  () => {};
    }

    const matches = current_evolutions
      .filter(( { start_time },  ) =>  parseFloat(start_time) < time )
      .sort((a,b) => parseFloat(b.start_time) - parseFloat(a.start_time));

    const match = matches.length
      ? matches[0]
      : {};

    const { start_time = null, value = null} = match;

    if (!value || time < parseFloat(start_time)) {
      setEvol1Source(null);
      setEvol2Source(null);
      setEvol3Source(null);

      return  () => {};
    }

    const outcomes = value.split("-");
    // Normalize sport_id for image paths (maps 11→10, 21→20 for 8-runner sports)
    const imageSportId = getSportIdForImagePath(sport_id);

    setEvol1Source(withBasePath('/images/runner_' + imageSportId + '_' + n_runners + '_' + outcomes[0] + '.png'));
    setEvol2Source(withBasePath('/images/runner_' + imageSportId + '_' + n_runners + '_' + outcomes[1] + '.png'));
    if (outcomes[2]) {
      setEvol3Source(withBasePath('/images/runner_' + imageSportId + '_' + n_runners + '_' + outcomes[2] + '.png'));
    } else {
      setEvol3Source(null);
    }
  }

  const init = () => {
    Emitter.on(EVENT_NAMES.MEDIA.EVOLUTION_PROCEED, onEvolutionChange);
    return () => {
      Emitter.off(EVENT_NAMES.MEDIA.EVOLUTION_PROCEED);
    }
  }

  React.useEffect(init, []);

  return (
    <>
      <img className="evolution-1" src={evol1_source}/>
      <img className="evolution-2" src={evol2_source}/>
      {evol3_source && <img className="evolution-3" src={evol3_source}/>}
    </>
  );
}

export default VideoEvolutions;

